import {Box, Grid, Typography, useTheme} from "@mui/material";
import {Link} from "@reach/router";
import {useResources} from "../../stores/ResourceProvider";
import useNavigationHelper from "../NavigationHelper";
import config from 'react-global-configuration';
import useIsMobile from "../useIsMobile";

const Footer = () => {
  const theme = useTheme()
  const styles = {
    footer: {
      display: "flex",
      flexGrow: 1,
      width: "100%",
      marginTop: theme.spacing(2),
      marginLeft: "-16px",
      padding: theme.spacing(2),
      backgroundColor: theme.palette.background.default
    },
    link: {
      color: theme.palette.text.primary,
      [theme.breakpoints.down('xs')]: {
        fontSize: 12
      },
      [theme.breakpoints.up('sm')]: {
        fontSize: 18
      },
      fontWeight: 600,
      textDecoration: "none"
    }
  }

  const {termsOfUse, privacyPolicy} = useResources()
  const {navigateHome} = useNavigationHelper()
  const version = config.get("version")
  const isMobile = useIsMobile()

  return (
    <Box sx={styles.footer}>
      <Grid container justifyContent="space-evenly" spacing={0}>
        <Grid item xs={3} sm={3} textAlign="center">
          <Link to="." onClick={() => navigateHome()} style={styles.link}>
            Home
          </Link>
        </Grid>
        <Grid item xs={3} sm={3} textAlign="center">
          <Link to="." onClick={() => privacyPolicy.show()} style={styles.link}>
            {isMobile ? "Privacy" : "Privacy Policy"}
          </Link>
        </Grid>
        <Grid item xs={3} sm={3} textAlign="center">
          <Link to="." onClick={() => termsOfUse.show()} style={styles.link}>
            {isMobile ? "Terms" : "Terms of Use"}
          </Link>
        </Grid>
        <Grid item xs={3} sm={3} textAlign="center">
          <Link to="." onClick={() => window.open('mailto:support@retirementbudgetcalculator.com', "_blank")} style={styles.link}>
            {isMobile ? "Contact" : "Contact Us"}
          </Link>
        </Grid>
        <Grid xs={12} justifyContent="center" mt={1}>
          <Typography variant="body2" align="center">
            &copy;&nbsp;2016-{new Date().getFullYear()} Retirement Budget Calculator LLC (All rights reserved)
          </Typography>
        </Grid>
        <Grid xs={12} justifyContent="center">
          <Typography variant="body2" align="center">
            Version {version}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  )
}

export default Footer